import { FormattedMessage } from 'react-intl'
import { Typography } from '@carto/meridian-ds/components'
import { Users } from 'features/account/types'
import { getAuthMethodDescription } from 'features/users/model/user'
import { Box, Tooltip } from '@mui/material'

function UserEmail({ user, showAuthMethod }: { user: Users; showAuthMethod?: boolean }) {
  const isCartoUser = user.user_metadata?.is_carto_user
  const authMethod = getAuthMethodDescription(user)

  return (
    <Box display="flex">
      <Tooltip title={user.email}>
        <Typography
          variant="body2"
          color="textPrimary"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
          mr={0.5}
        >
          {isCartoUser ? <FormattedMessage id={'account.supportAccess.userEmail'} /> : user.email}
        </Typography>
      </Tooltip>
      <Typography variant="body2" color="textSecondary" component="span">
        {showAuthMethod && `(${authMethod})`}
      </Typography>
    </Box>
  )
}

export default UserEmail
